import { render } from "./About.vue?vue&type=template&id=52e585e6&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=52e585e6&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/ru/views/about.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FAbout.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/views/about.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FAbout.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e585e6"]])

export default __exports__